/**
 * 页面元素转换图片 drawHtml
 * @param  {HTMLElement} element  目标 dom 元素
 * @param  {Object} options       html2canvas 配置参数, https://html2canvas.hertzen.com/configuration
 * @param  {Number} options.quality       图片质量, 0 ~ 1
 * @return {Promise}              图片数据 + canvas 对象，(Promise实例 .then去获取返回值)
 */
export const drawHtml = async (element, options = {}) => {
  const { default: html2canvas } = await import(/* webpackChunkName: 'lib-html2canvas' */ 'html2canvas')
  const { quality = 0.9, imageType = 'image/png', ...restOptions } = options
  const canvas = await html2canvas(element, {
    width: element.offsetWidth,
    height: element.offsetHeight,
    windowWidth: element.offsetWidth,
    windowHeight: element.offsetHeight,
    scale: 1,
    useCORS: true,
    logging: !!window.DEBUG,
    ignoreElements: (el) => {
      if (element.contains(el) || el.contains(element)) return false
      if (el.nodeName === 'HEAD' || el.nodeName === 'STYLE') return false
      else if (el.nodeName === 'LINK' && /\.css$/.test(el.href)) return false
      return true
    },
    ...restOptions
  })
  return {
    canvas,
    data: canvas.toDataURL(imageType, quality)
  }
}
